import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

export default function(WrappedComponent) {
  function Mobile(props) {
    const data = props.data
    if (data.mobile) {
      return <Redirect to={'/unsupported'} />
    }

    return <WrappedComponent {...props} />
  }

  Mobile.propTypes = {
    data: PropTypes.object,
  }

  return Mobile
}



// WEBPACK FOOTER //
// ./src/containers/HOC/Mobile.js